const LVHeart = () => (
	<>
		<mask id="mask0_6384_4732" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
			<rect y="0.0703125" width="24" height="24" fill="#D9D9D9" />
		</mask>
		<g mask="url(#mask0_6384_4732)">
			<path
				d="M18.4982 8.90564C18.4982 6.48456 16.9766 4.52148 15.0998 4.52148C14.1385 4.52148 13.2715 5.03705 12.6536 5.8649C12.3836 6.22677 12.1607 6.64804 11.9991 7.11218C11.8374 6.64804 11.6146 6.22677 11.3445 5.8649C10.7267 5.03705 9.85966 4.52148 8.89833 4.52148C7.0216 4.52148 5.5 6.48456 5.5 8.90564C5.5 9.3912 5.56184 9.8584 5.67512 10.295C5.67512 10.295 5.67574 10.2974 5.67757 10.3017C5.7633 10.6299 5.87841 10.941 6.01863 11.2294V11.2367C6.01863 11.2367 7.11161 13.8733 9.8713 17.2906C9.89701 17.3231 9.92273 17.3537 9.94784 17.3837C10.366 17.9183 10.8222 18.4755 11.3194 19.0529C11.677 19.4686 12.3224 19.4686 12.6806 19.0529C13.2053 18.443 13.6842 17.8564 14.1214 17.2955C14.1226 17.2943 14.1238 17.2925 14.125 17.2913C16.8841 13.8739 17.9777 11.2373 17.9777 11.2373C18.1198 10.9465 18.2361 10.6336 18.3224 10.3023C18.3237 10.2987 18.3249 10.2956 18.3249 10.2956C18.4382 9.85901 18.5 9.39182 18.5 8.90625L18.4982 8.90564Z"
				fill={'#6DAA63'}
			/>
		</g>
	</>
);

export default LVHeart;
